import { useQuery } from "react-query";
import { PagedRequestType } from "../types/PagedResults";
import { key_ScholarshipTypes } from "../utils/constants";
import { getScholarshipTypes } from "../services/school/scholarshipTypetype";


export const useGetScholarshipTypesQuery = (data: PagedRequestType, options:any = null) => {
    return useQuery([key_ScholarshipTypes, JSON.stringify(data)], () => getScholarshipTypes(data), options?{...options}:{});
};
